"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'avatar.preview.title': 'Vista previa del avatar',
    'avatar.preview.edit': 'Editar avatar',
    'avatar.preview.back': 'Volver a la lista',
    'avatar.preview.not_provided': 'No proporcionado',
    'avatar.preview.section.basic_info': 'Información básica',
    'avatar.preview.section.logo': 'Logo del avatar',
    'avatar.preview.section.description': 'Descripción',
    'avatar.preview.section.ai_model': 'Configuración del modelo de IA',
    'avatar.preview.section.knowledge': 'Base de conocimientos',
    'avatar.preview.section.settings': 'Configuración del avatar',
    'avatar.preview.section.validation': 'Estado de configuración',
    'avatar.preview.logo.not_uploaded': 'No se ha subido logo',
    'avatar.preview.provider': 'Proveedor',
    'avatar.preview.cost': 'Costo',
    'avatar.preview.model.not_selected': '¡No se ha seleccionado modelo de IA - Esto es requerido!',
    'avatar.preview.knowledge.entries_selected': 'entradas de conocimiento seleccionadas',
    'avatar.preview.knowledge.none_selected': 'No se han seleccionado entradas de base de conocimientos',
    'avatar.preview.validation.status': 'Validación de configuración',
    'avatar.preview.validation.complete': 'Todos los campos requeridos están completos',
    'avatar.preview.validation.incomplete': 'Faltan algunos campos requeridos',
    'avatar.preview.no_data': 'No hay datos de avatar disponibles',
    'avatar.preview.error.load_failed': 'Error al cargar el avatar para vista previa',
    'avatar.preview.voice.not_selected': 'No se ha seleccionado voz',
    'avatar.preview.unnamed': 'Avatar Sin Nombre',
    'avatar.preview.required': 'Requerido',
    'avatar.preview.gender.not_selected': 'No se ha seleccionado género',
    'avatar.preview.section.conversations': 'Conversaciones',
    'avatar.preview.conversations.empty': 'Aún no hay conversaciones con este avatar',
    'avatar.preview.conversations.untitled': 'Conversación sin título',
};
